import { Text } from "../../../design/text";
import SlateTextArea from "../../SlateTextArea/SlateTextArea";
import moment from "moment";
import { useAuth } from "../../../contexts/AuthContext";
import { Comment } from "../../../models/Comment";
import { useUser } from "../../../contexts/UserContext";
import DeleteCommentButton from "./DeleteCommentButton";

interface ReplyListProps {
  reply: Comment;
}

const ReplyListItem = ({ reply }: ReplyListProps) => {
  const { user } = useAuth();
  const { users } = useUser();
  const profile = users.find((user) => user._id === reply.createdById);
  const parsedContent =
    typeof reply.content === "string" ? JSON.parse(reply.content.trim()) : [];
  return (
    <div key={reply._id} style={{ marginBottom: "1rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="flex gap-1">
          <Text>
            <strong>{profile?.name}</strong> @{" "}
            {moment(reply.createdAt).fromNow()}
          </Text>
        </div>
        {user?.uid === reply.createdBy && (
          <DeleteCommentButton commentId={reply._id} />
        )}
      </div>
      <SlateTextArea
        id={reply._id}
        placeholder="Write a reply..."
        initialValue={parsedContent}
        readOnly={true}
      />
    </div>
  );
};

export default ReplyListItem;
